import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ToggleElModel} from "./toggle-el.model";

@Component({
  selector: 'app-toggle',
  templateUrl: './toggle.component.html',
  styleUrls: ['./toggle.component.scss'],
})
export class ToggleComponent {
  @Input() data: ToggleElModel = new ToggleElModel(-1);
  @Output() onChange: EventEmitter<any> = new EventEmitter<any>();
  @Input('inputId') inputId: any = -1;

  protected processOnChange() {
    if (this.data.readonly) {
      this.data.selected = false;
      return;
    }

    this.onChange.emit(this.data.selected);
  }
}
